import { useEffect } from 'react';
import useClient from './useClient';
import { ClientStatus } from '../../../model/types/ClientStatus';
import { ClientResponse } from '../../../model/types/ClientResponse';

interface ReturnType<T> {
  wrapClient(): void;
  data: T;
  status: ClientStatus;
  refetch(): void;
}

type ClientCall<T> = (...args) => Promise<ClientResponse<T>>;

export default <T> (client: ClientCall<T>, args: unknown[], deps = []): ReturnType<T> => {
  const {
    wrapClient, data, status,
  } = useClient<T>(client);

  useEffect(() => {
    wrapClient(...args)
      .catch(() => { /* noop */ });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  const refetch = (): void => {
    wrapClient(...args)
      .catch(() => { /* noop */ });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  return {
    wrapClient, data, status, refetch,
  };
};
